import { useRequest } from 'domain/core/hooks/useRequest';
import { useEffect } from 'react';
import { useContextSelector as useCS } from 'use-context-selector';
import { TUpdate } from 'domain/types';
import {
  ProfileConfigContext,
  TProfileConfigContextState,
} from 'domain/profileConfig/ProfileConfigContext';
import { profileConfigSelectors } from 'domain/profileConfig/selectors';

// TODO MADE ERRORS NOTIFICATION
export const useGetJobSeekerPreferences = () => {
  const update: TUpdate<TProfileConfigContextState> | undefined = useCS(
    ProfileConfigContext,
    profileConfigSelectors.update
  );

  const { data, isLoading } = useRequest({
    url: '/api/v1/profile',
    sendOnStart: true,
  });

  useEffect(() => {
    if (isLoading || !data) return;
    update?.({ jobSeekerPreferencesData: data });
  }, [data, isLoading, update]);

  return { data, isLoading };
};
